import { Box, Typography, Card, CardContent, Chip } from '@mui/material';
import DateRangeIcon from '@mui/icons-material/DateRange';

const formatDate = (date) => {
    if (!date) return 'Kein Datum';
    return new Date(date).toLocaleDateString('de-DE', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
    });
};

// Karte eines Trainings in der Historie.
function TrainingHistorieCard({ training, onOpen }) {
    return (
        <Card
            sx={{
                borderRadius: '16px',
                background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
                border: '1px solid rgba(59, 130, 246, 0.2)',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                height: '100%',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 12px 24px rgba(59, 130, 246, 0.15)',
                    borderColor: 'rgba(59, 130, 246, 0.4)',
                },
            }}
            onClick={onOpen}
        >
            <CardContent sx={{ p: 3 }}>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            color: '#e0f2fe',
                            fontWeight: 700,
                            mb: 1,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}
                        title={training.trainingsplan_name}
                    >
                        {training.trainingsplan_name || 'Training'}
                    </Typography>
                    <Chip
                        label={`${training.anzahl_uebungen || 0} Übungen`}
                        sx={{
                            bgcolor: 'rgba(34, 197, 94, 0.15)',
                            color: '#34d399',
                            fontWeight: 600,
                            borderRadius: '16px',
                        }}
                    />
                </Box>
                <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    sx={{ color: '#93c5fd', fontSize: '0.875rem' }}
                >
                    <DateRangeIcon sx={{ fontSize: 18 }} />
                    <Typography variant="caption" sx={{ color: '#93c5fd' }}>
                        {formatDate(training.datum)}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
}

export default TrainingHistorieCard;
